import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LocationButton, CloseButton } from './components/inputs/Button';
import Search from './components/inputs/Search';
import { Location } from './components/list/Locations';

type UserLocation = {
	latitude: number;
	longitude: number;
};

const App = () => {
	const [locations, setLocations] = useState<any[]>([]);
	const [locationList, setLocationsList] = useState<any[]>([]);
	const [userLocation, setUserLocation] = useState<UserLocation | null>(null);
	const [search, setSearch] = useState<string>('');

	const requestLocation = () => {
		if (!navigator.geolocation) {
			console.error('Geolocation is not supported by your browser.');
		} else {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setUserLocation({
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
					});
				},
				() => {
					console.error('Access to geolocation was denied.');
				}
			);
		}
	};

	const getLocations = async () => {
		// @ts-ignore
		if (window.CNP_location_data) {
			// @ts-ignore
			return window.CNP_location_data;
		} else {
			console.error("Error: Couldn't find location data.");
			return null;
		}
		// try {
		// 	// @ts-ignore
		// 	let query = `${WPO.Settings.getBlogUrl()}wp-json/wp/v2/location`;
		// 	return await axios.get(query);
		// } catch (error) {
		// 	console.log('Location error:', error);
		// }
		// return null;
	};

	const getDistance = (
		lat0: number,
		long0: number,
		lat1: number,
		long1: number
	): number => {
		let R = 6371;
		let latRadians = convertDegToRad(lat1 - lat0);
		let longRadians = convertDegToRad(long1 - long0);
		let a =
			Math.sin(latRadians / 2) * Math.sin(latRadians / 2) +
			Math.cos(convertDegToRad(lat0)) *
				Math.cos(convertDegToRad(lat1)) *
				Math.sin(longRadians / 2) *
				Math.sin(longRadians / 2);

		return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	};

	const convertDegToRad = (deg: number): number => {
		return deg * (Math.PI / 180);
	};

	useEffect(() => {
		getLocations()
			.then((response) => {
				if (response) {
					setLocations(response);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}, []);

	useEffect(() => {
		if (userLocation) {
			let locs = locations.sort(
				(a, b) =>
					getDistance(
						userLocation.latitude,
						userLocation.longitude,
						a['meta']['location_latitude'],
						a['meta']['location_longitude']
					) -
					getDistance(
						userLocation.latitude,
						userLocation.longitude,
						b['meta']['location_latitude'],
						b['meta']['location_longitude']
					)
			);

			setLocationsList(locs);
		}
	}, [userLocation]);

	useEffect(() => {
		if (search != '') {
			let locs = locations.filter((loc) => {
				let keywords = loc['meta']['location_search_keywords'];
				if (keywords) {
					console.log(loc['meta']['location_search_keywords']);
					return loc['meta']['location_search_keywords']
						.toLowerCase()
						.includes(search.toLowerCase());
				}

				return false;
			});

			setLocationsList(locs);
		} else {
			setLocationsList([]);
		}
	}, [search]);

	return (
		<>
			<div className='loc-shadow'></div>
			<div className='loc-popup-wrap'>
				<div className='loc-popup'>
					<CloseButton />
					<div className='inner'>
						<h3>Find Your Chicken N Pickle</h3>
						<span className='wp-block-buttons'>
							<LocationButton
								onClick={() => {
									requestLocation();
								}}
							/>
							<span className='h6'>OR</span>
							<Search
								onChange={(e) => {
									setSearch(e.target.value);
								}}
							/>
						</span>
						{locationList.length > 0 && (
							<>
								<hr />
								<div className='loc-list'>
									{locationList.map((location, index) =>
										index < 2 ? (
											<Location key={index} location={location} />
										) : null
									)}
								</div>
								<div className='wp-block-buttons'>
									<a
										className='wp-block-button is-style-white-outline'
										// @ts-ignore
										href={`${WPO.Settings.getBlogUrl()}locations`}
									>
										View All Locations
									</a>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default App;
